import React, { useState } from "react";
import TeacherModule from "../Teacher/TeacherModule";
import {
  Col,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardSubtitle,
  Collapse,
  Button,
  ListGroup,
  Row,
  Badge,
  ListGroupItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import CourseSubject from "./CourseSubject";
import { DeleteUpload } from "../../actions/teacherMutations";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import ConfirmDialog from "../Modal/ConfirmDialog";
import {
  getWinOptions,
  composeUrl,
  isGy25TestModule,
} from "../../Utilities/moduleHelper";
import { formatDate } from "../../Utilities/dateUtils";
import { FormattedMessage, useIntl } from "react-intl";
import Pacmanloader from "../Pacmanloader/Pacmanloader";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { BASE_LOGIN_REDIRECT_URL_NO_LWC } from "../../constants/api.constants";
import { buildDownloadFileName } from "../../Utilities/fileHelper";

const ResourceDownloadItem = ({ url, courseName, labelId }) => {
  const intl = useIntl();

  return (
    <DropdownItem
      tag="a"
      className="d-flex align-items-center lh-1 text-primary"
      href={`${BASE_LOGIN_REDIRECT_URL_NO_LWC}/${url}`}
      download={buildDownloadFileName(
        intl.formatMessage({ id: labelId }),
        courseName || intl.formatMessage({ id: "Course" }),
        url,
      )}
    >
      <FileDownloadIcon className="me-1 fs-6" />
      <FormattedMessage id={labelId} />
    </DropdownItem>
  );
};

const CourseItem = (props) => {
  const intl = useIntl();
  const [modDocsDropdownOpen, setModDocsDropdownOpen] = useState([]);
  const [showFullDescription, setShowFullDescription] = useState([]);
  const [promptDeleteUpload, setPromptDeleteUpload] = useState(false);
  const [courseDocuments, setCourseDocuments] = useState(
    props.course.courseUploads ? props.course.courseUploads : [],
  );

  const [uploadForRemoval, setUploadForRemoval] = useState([]);
  const mutateDeleteUpload = useMutation({ mutationFn: DeleteUpload });
  const [resourcesDropdownOpen, setResourcesDropdownOpen] = useState(false);

  const hasResources =
    props.course.teacherGuideFileUrl || props.course.glossaryFileUrl;

  const queryClient = useQueryClient();

  if (props.availableModuleAnswers?.isPending) {
    return <Pacmanloader></Pacmanloader>;
  }

  const handleDeleteUpload = () => {
    setPromptDeleteUpload(false);
    mutateDeleteUpload.mutate(
      {
        item: uploadForRemoval.item,
        classId: uploadForRemoval.classId,
        courseId: uploadForRemoval.courseId,
        teacherId: uploadForRemoval.teacherId,
      },
      {
        onSuccess: (data) => {
          if (data && data.status > 199 && data.status < 300) {
            toast.success(<FormattedMessage id="DocumentDeleted" />);
            queryClient.invalidateQueries({
              queryKey: ["FetchCoursesByClassId"],
            });
            setCourseDocuments([
              ...courseDocuments.filter(function (doc) {
                return doc.id !== uploadForRemoval.docId;
              }),
            ]);
            setUploadForRemoval([]);
          } else {
            toast.warn(data);
          }
        },
        throwOnError: true,
        onError: (data) => {
          toast.warn(data.response.data);
        },
      },
    );
  };

  const togglePromptDeleteUpload = (item, classId, courseId, docId) => {
    let deleteInfo = {
      item: item,
      classId: classId,
      courseId: courseId,
      teacherId: props.teacherInfo.data.id,
      docId: docId,
    };
    setUploadForRemoval(deleteInfo);
    setPromptDeleteUpload(true);
  };

  const handleOpenModule = (
    courseId,
    moduleId,
    moduleUrl,
    moduleType,
    isGy25FinalExam,
  ) => {
    const studentResultId = -1;

    const userId = -1;
    var url = composeUrl(
      userId,
      courseId,
      moduleId,
      moduleType,
      studentResultId,
      moduleUrl,
      null,
      null,
      isGy25FinalExam,
    );
    var winOptions = getWinOptions();
    window.open(url, "", winOptions);
  };

  let mappedModules = [];

  let moduleDocs = (moduleIdsAsString) => {
    let modulesIds = moduleIdsAsString.split(",");
    let modules = [];
    modulesIds.forEach((modId) => {
      props.course.modules.forEach((mod) => {
        if (mod.moduleId.toString() === modId) {
          modules.push(mod);
        }
      });
    });
    return modules.map((mod, index) => <div key={index}>{mod.name}</div>);
  };

  let modDocstoggle = (docId) => {
    if (!modDocsDropdownOpen.includes(docId)) {
      setModDocsDropdownOpen([...modDocsDropdownOpen, docId]);
    } else {
      setModDocsDropdownOpen([
        ...modDocsDropdownOpen.filter(function (id) {
          return id !== docId;
        }),
      ]);
    }
  };

  let hiddenDescStyle = {
    maxHeight: "40px",
    textOverflow: "ellipsis",
    fontWeight: "normal",
    overflow: "hidden",
  };

  let showingDescStyle = {
    maxHeight: "300px",
    textOverflow: "none",
    fontWeight: "normal",
    overflow: "visible",
  };

  let handleShowFullDescription = (courseId) => {
    if (!showFullDescription.includes(courseId)) {
      setShowFullDescription([...showFullDescription, courseId]);
    } else {
      setShowFullDescription([
        ...showFullDescription.filter(function (id) {
          return id !== courseId;
        }),
      ]);
    }
  };

  let mappedDocuments = [];
  if (props.displayDocuments) {
    mappedDocuments = courseDocuments.map((doc) => {
      const href = doc.fileUrl ?? doc.value;
      return (
        <ListGroupItem key={href} className="ps-0">
          <Row style={{ alignItems: "center" }} className="ml-1">
            <Col xs="auto" className="pe-0">
              <FontAwesomeIcon icon="link" className="text-primary" />
            </Col>
            <Col className="text-truncate" style={{ minWidth: 0 }}>
              <a href={href} title={doc.value}>
                {doc.value}
              </a>
            </Col>
            <Col
              xs="12"
              md="auto"
              className="d-flex align-items-center justify-content-end gap-2 ms-md-auto"
            >
              {doc.moduleIdsAsString ? (
                <Dropdown
                  isOpen={modDocsDropdownOpen.includes(doc.id)}
                  toggle={() => modDocstoggle(doc.id)}
                >
                  <DropdownToggle
                    color="primary"
                    style={{ fontSize: ".8em" }}
                    outline
                    caret
                  >
                    <FormattedMessage id="Modules" />
                  </DropdownToggle>
                  <DropdownMenu>
                    {moduleDocs(doc.moduleIdsAsString)}
                  </DropdownMenu>
                </Dropdown>
              ) : (
                ""
              )}
              <span>{formatDate(doc.uploaded, "yyyy-MM-dd")}</span>
              {doc.uploadedBy === props.teacherInfo.data.id}
              <FontAwesomeIcon
                icon="circle-xmark"
                className="text-danger"
                style={{ cursor: "pointer" }}
                title={intl.formatMessage({ id: "Delete" })}
                onClick={() =>
                  togglePromptDeleteUpload(
                    doc.value,
                    doc.classId,
                    doc.courseId,
                    doc.id,
                  )
                }
              />
            </Col>
          </Row>
        </ListGroupItem>
      );
    });
  }

  // A gy25 final exam never gets a row here, so it must not keep a play
  // button slot alive either.
  const renderedModules = props.course.modules.filter(
    (module) => !(module.isGy25 && module.isFinalExam),
  );

  const courseHasNonTestModules = renderedModules.some(
    (module) => !isGy25TestModule(module),
  );
  const courseHasTestModules = renderedModules.some(isGy25TestModule);

  mappedModules = renderedModules.map((module) => {
    // A test module coupled to a fact module is rendered inside that fact
    // module's row, so it must not get a row of its own.
    if (
      isGy25TestModule(module) &&
      module.moduleCoupleId != null &&
      renderedModules.some(
        (m) => m.moduleCoupleId === module.moduleCoupleId && m.isFactModule,
      )
    ) {
      return null;
    }

    const answersInfo = props.availableModuleAnswers?.data?.find(
      (mod) => mod.moduleId === module.moduleId,
    );

    const studyTasksAvailable =
      module.isFactModule && module.moduleCoupleId != null;

    const coupledTestModule = studyTasksAvailable
      ? renderedModules.find(
          (m) =>
            m.moduleCoupleId === module.moduleCoupleId && isGy25TestModule(m),
        )
      : undefined;

    return (
      <TeacherModule
        key={module.moduleId}
        module={module}
        coupledTestModule={coupledTestModule}
        courseHasNonTestModules={courseHasNonTestModules}
        courseHasTestModules={courseHasTestModules}
        courseId={props.course.id}
        runModule={handleOpenModule}
        answersAvailable={!!answersInfo}
        answersFileName={answersInfo?.answersFile}
        studyTasksAvailable={studyTasksAvailable}
        studyTasksDefaultQuestionCount={
          coupledTestModule?.defaultNumberOfQuestionsInFinalExam
        }
      />
    );
  });

  return (
    <Col
      md="6"
      lg="4"
      xs="12"
      style={
        resourcesDropdownOpen
          ? { position: "relative", zIndex: 1000 }
          : undefined
      }
    >
      <Card>
        <CardImg
          top
          src={props.course.imgUrl}
          alt="Card image cap"
          className="mb-0 img-fluid"
          style={{ overflow: "hidden", maxHeight: "250px" }}
        />

        <div>
          <CourseSubject subject={props.course.subject} />
        </div>
        <CardBody className="mt-0">
          <CardTitle className="text-truncate" title={props.course.courseName}>
            <strong>{props.course.courseName}</strong>
          </CardTitle>
          <CardSubtitle
            title={props.course.description}
            className="mb-2 pre-scrollable"
            style={{ minHeight: "65px", overflow: "auto" }}
          >
            <div
              style={
                showFullDescription.includes(props.course.id)
                  ? showingDescStyle
                  : hiddenDescStyle
              }
            >
              {props.course.description}
            </div>
            <div>
              <span
                onClick={() => handleShowFullDescription(props.course.id)}
                className="fake-link d-block"
              >
                {showFullDescription.includes(props.course.id) ? (
                  <FormattedMessage id="ReadLess" />
                ) : (
                  <FormattedMessage id="ReadMore" />
                )}
              </span>
            </div>
          </CardSubtitle>
          <Row>
            <Col
              xs={
                hasResources
                  ? props.displayDocuments
                    ? "4"
                    : "6"
                  : props.displayDocuments
                    ? "6"
                    : "12"
              }
              className="p-0"
            >
              <Button
                active={props.modulesIsOpen}
                color="light"
                onClick={() => props.toggleModules(props.course.id)}
                className="text-left w-100 p-1"
                inline="false"
              >
                <FontAwesomeIcon
                  icon={props.modulesIsOpen ? "caret-up" : "caret-down"}
                />
                &nbsp; <FormattedMessage id="Modules" />
              </Button>
            </Col>
            {props.displayDocuments ? (
              <Col xs={hasResources ? "4" : "6"} className="p-0">
                <Button
                  active={props.documentIsOpen}
                  color="light"
                  className="text-left w-100 p-1"
                  inline="true"
                  onClick={() => props.toggleDocumentOpen(props.course.id)}
                >
                  <FontAwesomeIcon
                    icon={
                      props.openedDocuments.includes(props.course.id)
                        ? "caret-up"
                        : "caret-down"
                    }
                  />
                  &nbsp; <FormattedMessage id="Documents" />
                  <Badge className="float-right ms-2" pill color="primary">
                    {courseDocuments.length}
                  </Badge>
                </Button>
              </Col>
            ) : (
              ""
            )}

            {hasResources ? (
              <Col xs={props.displayDocuments ? "4" : "6"} className="p-0">
                <Dropdown
                  isOpen={resourcesDropdownOpen}
                  toggle={() =>
                    setResourcesDropdownOpen(!resourcesDropdownOpen)
                  }
                >
                  <DropdownToggle
                    active={resourcesDropdownOpen}
                    color="light"
                    className="text-left w-100 p-1"
                  >
                    <FontAwesomeIcon
                      className="me-1"
                      icon={resourcesDropdownOpen ? "caret-up" : "caret-down"}
                    />
                    <FormattedMessage id="Resources" />
                  </DropdownToggle>
                  <DropdownMenu className="w-100">
                    {props.course.teacherGuideFileUrl ? (
                      <ResourceDownloadItem
                        url={props.course.teacherGuideFileUrl}
                        courseName={props.course.courseName}
                        labelId="Guide"
                      />
                    ) : (
                      ""
                    )}
                    {props.course.glossaryFileUrl ? (
                      <ResourceDownloadItem
                        url={props.course.glossaryFileUrl}
                        courseName={props.course.courseName}
                        labelId="Glossary"
                      />
                    ) : (
                      ""
                    )}
                  </DropdownMenu>
                </Dropdown>
              </Col>
            ) : (
              ""
            )}
          </Row>

          <Row>
            <Col md={12} className="p-0">
              <Collapse isOpen={props.modulesIsOpen}>
                <ListGroup>{mappedModules}</ListGroup>
              </Collapse>
            </Col>
          </Row>
          {props.displayDocuments ? (
            <Row>
              <Col md={12} className="p-0">
                <Collapse
                  isOpen={props.openedDocuments.includes(props.course.id)}
                >
                  <ListGroup>{mappedDocuments}</ListGroup>
                </Collapse>
              </Col>
            </Row>
          ) : (
            ""
          )}
        </CardBody>
      </Card>

      <ConfirmDialog
        isOpen={promptDeleteUpload}
        toggle={() => setPromptDeleteUpload(!promptDeleteUpload)}
        title={<FormattedMessage id="AreYouSure" />}
        message={
          <FormattedMessage
            values={{ document: uploadForRemoval.item }}
            id="DocumentWillBeDeleted"
          />
        }
        onProceed={handleDeleteUpload}
      />
    </Col>
  );
};

export default CourseItem;
